// extracted by mini-css-extract-plugin
module.exports = {"active":"SidebarItem_active__1m1V_","sidebarItem":"SidebarItem_sidebarItem__J7hTQ"};